import {environment} from "../../../environments/environment";

export interface RootObject {
    items: Product[];
    total_count: number;
}

export class Product {
    id: number;
    sku: string;
    price: number;

    description: string;
    name: string;
    media_gallery_entries: ImageEntry[];
    custom_attributes: CustomAttributes[];
    attributeSetId: number
    createdAt: string
    extension_attributes: any
    options: [any]
    // var productLinks : [ProductLink]?
    status: number
    tier_prices: [any]
    typeId: number
    visibility: number
    type_id: string

    getImage() {
        return environment.baseCatalogUrl + environment.baseImagePath + this.getCustomAttrByKey('thumbnail');
        // if (this.media_gallery_entries[0] == undefined) {
        //
        //
        //     console.log('image undefiend' + this.name);
        // } else {
        //     return environment.baseCatalogUrl + environment.baseImagePath + this.getCustomAttrByKey('thumbnail');
        //     //return environment.baseCatalogUrl + environment.baseImagePath + this.media_gallery_entries[0].file;
        // }
    }

    getCachedImage() {

        if (this.media_gallery_entries[0] == undefined) {
        //    console.log('image undefiend' + this.name);
        } else {
            // console.log('we are here');
            return environment.baseCatalogUrl + environment.cachedImagePath + this.getCustomAttrByKey('thumbnail');
            //return environment.baseCatalogUrl + environment.baseImagePath + this.media_gallery_entries[0].file;
        }
    }

    getExtentionAttByKey(key) {

        return this.extension_attributes[key];

    }


    inStock() {


        if (this.extension_attributes['in_stock'] == 1) {
            return true;
        } else {
            return false;
        }
    }

    getFullImage(image_url) {
        return image_url + this.getImage();
    }

    getLink() {
        return environment.base + '/product/details/' + this.sku;
    }

    getCustomAttrByKey(key) {

        let special_price = null;
        this.custom_attributes.forEach(item => {

            if (item.attribute_code == key) {
                special_price = item.value;

            }

        });

        return special_price;

    }

    hasSpecialPrice(): boolean {
        let special_txt;
         special_txt = this.getCustomAttrByKey("special_price")
        if (special_txt == '' || special_txt == null) {
            special_txt = this.tier_prices[0]?.value;
            if (special_txt == '' || special_txt == null) {
                return false;
            }
        }


        let special_from = this.getCustomAttrByKey("special_from_date");
        let special_to = this.getCustomAttrByKey("special_to_date");
        let now = new Date();

        let dateFormatter = Date()
        // dateFormatter.dateFormat = "yyyy-M-dd hh:mm:ss"

        if (special_from != null && special_from != "") {

            let date_from = new Date(special_from)

            if (now.getTime() < date_from.getTime()) {
                return false
            }

        }


        if (special_to != null && special_to != "") {
            let date_to = new Date(special_to)

            if (now.getTime() > date_to.getTime()) {
                return false
            }
        }

        let special = Number(special_txt);

        if (special == 0 || special == this.price) {
            return false;
        } else {
            return true
        }
    }

    getSpecialPrice(): number {
        let special;
        special = this.getCustomAttrByKey("special_price");
        if (special == '' || special == null) {
            special = this.tier_prices[0]?.value ;
        }


        return (special);
    }

    getDiscountPct(): number {

        let pct: number = (((this.price) - (this.getSpecialPrice())) / (this.price))

        return Math.round(pct * 100);

    }

}

export interface ImageEntry {
    id: number;
    extension_attributes:any;
    file: string;

}

export interface CustomAttributes {
    attribute_code: string;
    value: string;
}


